var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PagerBox"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.total,"page-size":_vm.page_size},on:{"current-change":_vm.changCurrentPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }